
<template>
<div class="preloader " :class="{animated:closeBlock}">
  <div class="preloader__container">
  <div class="logo">
    <div class="svg-anime">
    <PreloaderLetters @animationComplete="closeBlock=true"/>
    </div>
  </div>
  <div class="bottom">

  </div>
  </div>
</div>
</template>
<script setup lang="ts">
import {ref} from 'vue';
import PreloaderLetters from "@components/Preloader/preloaderLetters.vue";

defineOptions({
  name:'Preloader'
});
const isEnd = ref(false);
const closeBlock = ref(false);

</script>

<style scoped lang="scss">
@keyframes logo {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0.3;
  }
  70% {
    opacity: 0.7;
  }
  99% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

  .preloader{
    position: fixed;
    z-index: var(--z-index-preloader-bg);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--color-black);
    overflow: hidden;
    &.animated{
      height: 0;
      transition: height 2s cubic-bezier(.64,0,.36,1);
    }
    &__container{
      width: 100%;
      display: flex;
      flex-direction: column;
      .logo{
        height: 70dvh;
        position: relative;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .svg-anime{
          width: 39.8rem;
          margin-bottom: 11.9rem;
          @media screen and (max-width: 769px) {
            width: 24.9rem;
          }
        }
      }
      .bottom{
        opacity: 0;
        height: 30dvh;
        background: url("/img/map.png") no-repeat center;
        background-size: cover;
        animation:  2s ease-out 1s forwards logo;
      }
    }

  }
</style>